/** UK postcode validation and normalisation. */

const UK_POSTCODE_REGEX =
  /^([A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2})$/i;

export function normalizeUkPostcode(input: string): string {
  const compact = input.trim().toUpperCase().replace(/\s+/g, "");
  if (compact.length < 5) return compact;
  return `${compact.slice(0, -3)} ${compact.slice(-3)}`;
}

export function isValidUkPostcode(input: string): boolean {
  const normalized = normalizeUkPostcode(input);
  return UK_POSTCODE_REGEX.test(normalized);
}

export function outwardCode(postcode: string): string | null {
  const normalized = normalizeUkPostcode(postcode).replace(/\s+/g, "");
  const match = normalized.match(/^([A-Z]{1,2}\d{1,2}[A-Z]?)/);
  return match ? match[1] : null;
}
